/**
 * Barra degli sconti progressivi Lyoss.
 * La fascia usa il subtotale dopo gli sconti prodotto e prima degli sconti ordine.
 */
(function () {
  "use strict";

  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : "/";
  var refreshTimer = null;
  var refreshRevision = 0;
  var cartSubscription = null;
  var stickyTicking = false;

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format);
    }
    return new Intl.NumberFormat(document.documentElement.lang || "it-IT", {
      style: "currency",
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR",
    }).format((cents || 0) / 100);
  }

  function tiers(container) {
    return Array.prototype.map.call(container.querySelectorAll("[data-tier-threshold]"), function (step) {
      return {
        threshold: parseInt(step.dataset.tierThreshold, 10) || 0,
        discount: parseFloat(step.dataset.tierDiscount) || 0,
        label: step.dataset.tierLabel || "",
        title: step.dataset.tierTitle || "",
        step: step,
      };
    }).filter(function (tier) {
      return tier.threshold > 0 && tier.discount > 0;
    }).sort(function (a, b) {
      return a.threshold - b.threshold;
    });
  }

  function milestones(container) {
    return Array.prototype.map.call(container.querySelectorAll("[data-step-threshold]"), function (step) {
      return {
        threshold: parseInt(step.dataset.stepThreshold, 10) || 0,
        type: step.dataset.stepType || "",
        label: step.dataset.stepLabel || "",
        discount: parseFloat(step.dataset.tierDiscount) || 0,
        step: step,
      };
    }).filter(function (milestone) {
      return milestone.threshold > 0;
    }).sort(function (a, b) {
      return a.threshold - b.threshold;
    });
  }

  function rewardLabel(milestone) {
    if (!milestone) return "";
    if (milestone.type === "discount") return milestone.label || ("il " + milestone.discount + "% di sconto");
    var label = milestone.label || "Spedizione gratuita";
    return label.charAt(0).toLocaleLowerCase() + label.slice(1);
  }

  function unlockedLabel(milestone) {
    if (!milestone) return "";
    if (milestone.type === "discount") return milestone.discount + "% di sconto";
    return milestone.label || "Spedizione gratuita";
  }

  function normalized(value) {
    return String(value || "").trim().toLocaleLowerCase();
  }

  function applicationTitle(allocation) {
    if (!allocation) return "";
    if (allocation.discount_application && allocation.discount_application.title) {
      return allocation.discount_application.title;
    }
    return allocation.title || "";
  }

  function isProgressive(title, availableTiers) {
    var candidate = normalized(title);
    if (!candidate) return false;
    return availableTiers.some(function (tier) {
      return normalized(tier.title) === candidate;
    });
  }

  function referenceSubtotal(cart, availableTiers) {
    availableTiers = availableTiers || tiers(document.querySelector(".npd-container") || document);
    var value = cart && cart.original_total_price != null
      ? cart.original_total_price
      : cart && cart.items_subtotal_price;
    value = value || 0;

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        if (!isProgressive(applicationTitle(allocation), availableTiers)) {
          value -= allocation.amount || 0;
        }
      });
    });

    (cart.cart_level_discount_applications || []).forEach(function (application) {
      if (!isProgressive(application.title, availableTiers)) {
        value -= application.total_allocated_amount || 0;
      }
    });

    return Math.max(0, value);
  }

  function setState(step, state) {
    step.classList.remove("npd-step--completed", "npd-step--active", "npd-step--pending");
    step.classList.add("npd-step--" + state);
    step.setAttribute("aria-current", state === "active" ? "step" : "false");
  }

  function updateConnectors(steps, value) {
    steps.forEach(function (step, index) {
      if (index === 0) return;
      var previous = parseInt(steps[index - 1].dataset.stepThreshold, 10) || 0;
      var current = parseInt(step.dataset.stepThreshold, 10) || 0;
      var progress = 0;
      if (value >= current) progress = 100;
      else if (value > previous && current > previous) progress = ((value - previous) / (current - previous)) * 100;
      step.style.setProperty("--npd-fillw", Math.max(0, Math.min(100, progress)) + "%");
    });
  }

  function render(container, cart) {
    var availableTiers = tiers(container);
    var availableMilestones = milestones(container);
    if (!availableMilestones.length) return;
    var value = referenceSubtotal(cart, availableTiers);

    var current = null;
    var next = null;
    availableMilestones.forEach(function (milestone) {
      if (value >= milestone.threshold) current = milestone;
      else if (!next) next = milestone;
    });

    var steps = Array.prototype.slice.call(container.querySelectorAll("[data-step-threshold]"));
    steps.forEach(function (step) {
      var threshold = parseInt(step.dataset.stepThreshold, 10) || 0;
      if (threshold === 0 || value >= threshold) setState(step, "completed");
      else if (next && step === next.step) setState(step, "active");
      else setState(step, "pending");
    });
    updateConnectors(steps, value);

    var message = container.querySelector("[data-progress-message]");
    var incentive = message && message.querySelector("[data-progress-incentive]");
    var unlocked = message && message.querySelector("[data-progress-unlocked]");
    var format = container.dataset.moneyFormat || "";
    if (incentive) {
      if (next) {
        var missing = Math.max(0, next.threshold - value);
        incentive.textContent = "Aggiungi " + formatMoney(missing, format) + " per ottenere " + rewardLabel(next);
        if (unlocked) {
          unlocked.textContent = current ? "Sbloccato: " + unlockedLabel(current) : "";
          unlocked.hidden = !current;
        }
      } else if (availableTiers.length) {
        incentive.textContent = "Hai sbloccato lo sconto massimo del " + availableTiers[availableTiers.length - 1].discount + "%";
        if (unlocked) unlocked.hidden = true;
      } else {
        incentive.textContent = "Hai sbloccato " + unlockedLabel(availableMilestones[availableMilestones.length - 1]);
        if (unlocked) unlocked.hidden = true;
      }
    }

    if (unlocked) {
      var shippingUnlocked = availableMilestones.some(function (milestone) {
        return milestone.type === "shipping" && value >= milestone.threshold;
      });
      unlocked.classList.toggle("npd-message__unlocked--shipping", shippingUnlocked);
      if (shippingUnlocked) {
        unlocked.textContent = "Hai la spedizione GRATIS";
        if (next && current && current.type === "discount") {
          unlocked.textContent += " · Sconto " + current.discount + "%";
        }
        unlocked.hidden = false;
      }
    }

    var count = container.querySelector("[data-unlocked-count]");
    if (count) count.textContent = availableMilestones.filter(function (milestone) { return value >= milestone.threshold; }).length + "/" + availableMilestones.length;

    container.dataset.cartEmpty = cart.item_count === 0 ? "true" : "false";
    syncStickyCopy(container);
    updateStickyCopies();
  }

  function syncStickyCopy(container) {
    var copy = container.querySelector(":scope > .npd-sticky-copy");
    if (!copy) return;
    var header = container.querySelector(":scope > .npd-header");
    var stepper = container.querySelector(":scope > .npd-stepper");
    if (!header || !stepper) return;
    copy.innerHTML = header.outerHTML + stepper.outerHTML;
    var liveMessage = copy.querySelector("[aria-live]");
    if (liveMessage) liveMessage.removeAttribute("aria-live");
    copy.querySelectorAll("[data-progress-message], [data-progress-incentive], [data-progress-unlocked], [data-step-threshold], [data-tier-threshold]").forEach(function (element) {
      element.removeAttribute("data-progress-message");
      element.removeAttribute("data-progress-incentive");
      element.removeAttribute("data-progress-unlocked");
      element.removeAttribute("data-step-threshold");
      element.removeAttribute("data-step-type");
      element.removeAttribute("data-step-label");
      element.removeAttribute("data-tier-threshold");
      element.removeAttribute("data-tier-discount");
      element.removeAttribute("data-tier-label");
      element.removeAttribute("data-tier-title");
      element.removeAttribute("aria-current");
    });
  }

  function setupStickyCopies() {
    document.querySelectorAll(".npd-container[data-mobile-sticky='true']").forEach(function (container) {
      if (container.querySelector(":scope > .npd-sticky-copy")) return;
      var copy = document.createElement("div");
      copy.className = "npd-sticky-copy";
      copy.dataset.active = "false";
      copy.setAttribute("aria-hidden", "true");
      container.appendChild(copy);
      syncStickyCopy(container);
    });
  }

  function updateStickyCopies() {
    stickyTicking = false;
    var mobile = window.matchMedia("(max-width: 749px)").matches;
    var activeHeight = 0;

    document.querySelectorAll(".npd-container").forEach(function (container) {
      var copy = container.querySelector(":scope > .npd-sticky-copy");
      if (!copy) return;
      var active = mobile && container.dataset.cartEmpty !== "true" && container.getBoundingClientRect().bottom <= 0;
      copy.dataset.active = active ? "true" : "false";
      if (active) activeHeight = Math.max(activeHeight, copy.offsetHeight);
    });

    if (updateStickyCopies.lastHeight !== activeHeight) {
      updateStickyCopies.lastHeight = activeHeight;
      document.dispatchEvent(new CustomEvent("n:progressive-discounts:dock", {
        detail: { active: activeHeight > 0, height: activeHeight }
      }));
    }
  }

  function requestStickyUpdate() {
    if (stickyTicking) return;
    stickyTicking = true;
    window.requestAnimationFrame(updateStickyCopies);
  }

  function fetchCart() {
    return fetch(root + "cart.js", {
      cache: "no-store",
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("Impossibile leggere il carrello");
      return response.json();
    });
  }

  function renderCart(cart) {
    setupStickyCopies();
    document.querySelectorAll(".npd-container").forEach(function (container) {
      render(container, cart);
    });
  }

  function refresh(event) {
    window.clearTimeout(refreshTimer);
    var revision = ++refreshRevision;
    var payload = event && (event.detail || event);
    var cart = payload && (payload.cartData || payload.cart);
    if (cart && !cart.errors && Array.isArray(cart.items) && typeof cart.item_count === "number") {
      renderCart(cart);
      return;
    }
    refreshTimer = window.setTimeout(function () {
      if (!document.querySelector(".npd-container")) return;
      fetchCart().then(function (cart) {
        if (revision === refreshRevision) renderCart(cart);
      }).catch(function (error) {
        console.error("[n-progressive-discounts]", error);
      });
    }, 80);
  }

  function subscribeToCart() {
    if (cartSubscription) return;
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
      cartSubscription = subscribe(PUB_SUB_EVENTS.cartUpdate, refresh) || true;
    }
  }

  function bindDetails() {
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-discount-details-trigger]");
      if (!button) return;
      var container = button.closest(".npd-container");
      var details = container && container.querySelector("[data-discount-details]");
      if (!details) return;
      details.hidden = !details.hidden;
      button.setAttribute("aria-expanded", details.hidden ? "false" : "true");
    });
  }

  function init() {
    bindDetails();
    setupStickyCopies();
    refresh();
    document.addEventListener("cart:updated", refresh);
    document.addEventListener("cart:refresh", refresh);
    document.addEventListener("shopify:section:load", function () {
      subscribeToCart();
      setupStickyCopies();
      refresh();
    });
    document.addEventListener("change", function (event) {
      if (event.target.closest("cart-items, cart-drawer, cart-drawer-items")) subscribeToCart();
    });
    subscribeToCart();
    window.addEventListener("scroll", requestStickyUpdate, { passive: true });
    window.addEventListener("resize", requestStickyUpdate);
    window.addEventListener("load", function () {
      subscribeToCart();
      refresh();
    }, { once: true });
    requestStickyUpdate();
  }

  window.NProgressiveDiscounts = { refresh: refresh, subtotal: referenceSubtotal };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
